import { createContext, PropsWithChildren, useMemo, useState } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'
import gsap from 'gsap'

import { useLoader } from '@/store/loader'

import { useTimeline } from './useTimeline'

export const TimelineContext = createContext<GSAPTimeline | undefined>(undefined)

export const IntroTimeline = () => {
  console.log('IntroTimeline')
  const timeline = useTimeline()
  const complete = useLoader((state) => state.complete)

  useIsomorphicLayoutEffect(() => {
    console.log('INTRO TIMELINE')
    const unsubscribe = useLoader.subscribe(
      (state) => state.compiled,
      async (compiled) => {
        if (compiled) {
          unsubscribe()
          console.log('INTRO TIMELINE START', timeline.duration())
          await timeline.play()
          complete()
          console.log('INTRO TIMELINE COMPLETE')
        }
      }
    )

    return () => {
      unsubscribe()
    }
  }, [])

  return null
}

const TimelineProvider = ({ children }: PropsWithChildren) => {
  const [timeline] = useState(() => gsap.timeline({ paused: true }))
  const contextValue = useMemo(() => timeline, [timeline])

  return <TimelineContext.Provider value={contextValue}>{children}</TimelineContext.Provider>
}

export default TimelineProvider
